function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pen",
  transform: "translate(-3 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_29235",
  "data-name": "Path 29235",
  d: "M32.721,3.455a1.551,1.551,0,0,0-2.195,0L29.175,4.807a4.654,4.654,0,0,0-5.3.91L7.433,22.162l8.772,8.772L32.653,14.487a4.649,4.649,0,0,0,.909-5.294L34.915,7.84a1.551,1.551,0,0,0,0-2.193L32.72,3.455ZM26.1,16.651l-9.9,9.9-4.385-4.387,9.9-9.9L26.1,16.652Zm2.819-2.819L30.457,12.3a1.551,1.551,0,0,0,0-2.195l-2.19-2.193a1.551,1.551,0,0,0-2.195,0L24.537,9.444l4.385,4.388Z",
  transform: "translate(0.15 0)",
  fill: "#8b8c8e",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_29236",
  "data-name": "Path 29236",
  d: "M3,34.819,6.29,22.758l8.77,8.772Z",
  transform: "translate(0 0.667)",
  fill: "#8b8c8e"
}));
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.518,
    height: 32.485,
    viewBox: "0 0 32.518 32.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/editPen.e99e6dd8.svg";
export { ForwardRef as ReactComponent };